import { cB as i, c as r } from "./highrise373.mjs";
const t = i("p", `
 box-sizing: border-box;
 transition: color .3s var(--n-bezier);
 margin: var(--n-margin);
 font-size: var(--n-font-size);
 line-height: var(--n-line-height);
 color: var(--n-text-color);
`, [r("&:first-child", "margin-top: 0;"), r("&:last-child", "margin-bottom: 0;")]);
export {
  t as default
};
